import { groupBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ProductionGroup } from '@paragon/contract-library';

import { RootState } from '../slices';
import { getProjectLayoutModels } from './getProjectLayoutModels';

export const getProductionGroupsByProjectGuid = createSelector(
  getProjectLayoutModels,
  (state: RootState) => state.productionGroups,

  (projectLayoutModels, productionGroups) => {
    const productionGroupsGroupedByProjectGuid = groupBy(
      Object.values(productionGroups),
      (productionGroup) => productionGroup.projectGuid,
    );
    return projectLayoutModels.reduce(
      (productionGroupsByProjectGuid, projectLayoutModel) => {
        productionGroupsByProjectGuid[projectLayoutModel.guid] =
          productionGroupsGroupedByProjectGuid[projectLayoutModel.guid] ?? [];
        return productionGroupsByProjectGuid;
      },
      {} as { [projectGuid: string]: readonly ProductionGroup[] },
    );
  },
);
